import styled from 'styled-components';

export const ResetPasswordButtonWrapper = styled.div`
  margin-top: 40px;
`;
